import React from "react"
import Autocomplete from "@material-ui/lab/Autocomplete"
import Geocode from "react-geocode"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import parse from "autosuggest-highlight/parse"
import throttle from "lodash/throttle"

import TextField from "../components/TextField"
import loadScript from "../libs/loadScript"

const apiKey = "AIzaSyBwW6jaBQ4pnhjBWDNKfiF3igWz9zUw5ow"
Geocode.setApiKey(apiKey)

const autocompleteService = { current: null }

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}))

export default function GoogleMapsField(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(props.value)
  const [inputValue, setInputValue] = React.useState("")
  const [options, setOptions] = React.useState([])
  const loaded = React.useRef(false)

  if (typeof window !== "undefined" && !loaded.current) {
    if (!document.querySelector("#google-maps")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`,
        document.querySelector("head"),
        "google-maps"
      )
    }
    loaded.current = true
  }

  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        autocompleteService.current.getPlacePredictions(request, callback)
      }, 200),
    []
  )

  React.useEffect(() => {
    let active = true

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService()
    }
    if (!autocompleteService.current) {
      return undefined
    }

    if (inputValue === "") {
      setOptions(value ? [value] : [])
      return undefined
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = []

        if (value) {
          newOptions = [value]
        }
        if (results) {
          newOptions = [...newOptions, ...results]
        }

        setOptions(newOptions)
      }
    })

    return () => {
      active = false
    }
  }, [value, inputValue, fetch])

  return (
    <Autocomplete
      id="google-maps-field"
      getOptionLabel={(option) => (typeof option === "string" ? option : option.description)}
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options)
        setValue(newValue)
        if (newValue && newValue.description) {
          Geocode.fromAddress(newValue.description).then(
            (response) => {
              const { lat, lng } = response.results[0].geometry.location
              props.setAddress({
                ...props.address,
                addressFull: newValue && newValue.description ? newValue.description : "",
                addressParts: newValue && newValue.terms ? newValue.terms : "",
                latLong: {
                  lat,
                  lng,
                },
              })
            },
            (error) => {
              console.error(error)
            }
          )
        }
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant="outlined"
          fullWidth
          error={props.error ? true : false}
          // InputProps={{
          //   startAdornment: (
          //     <InputAdornment position="start">
          //       <LocationOnIcon />
          //     </InputAdornment>
          //   ),
          // }}
        />
      )}
      renderOption={(option) => {
        const matches = option.structured_formatting.main_text_matched_substrings
        const parts = parse(
          option.structured_formatting.main_text,
          matches.map((match) => [match.offset, match.offset + match.length])
        )

        return (
          <Grid container alignItems="center">
            <Grid item>
              <LocationOnIcon className={classes.icon} />
            </Grid>
            <Grid item xs>
              {parts.map((part, index) => (
                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                  {part.text}
                </span>
              ))}

              <Typography variant="body2" color="textSecondary">
                {option.structured_formatting.secondary_text}
              </Typography>
            </Grid>
          </Grid>
        )
      }}
    />
  )
}
